/* template */
<template><page><div :class='["scroll-nav-bar-page"]'><base-container><div :class='["demo-block"]'><scroll-nav-bar :labels="(serviceList)" :txts="(serviceTxts)" :current="(currentService)" :options="(navOptions)" @change='(e)=>__invoke(e, [["onServiceChange"]])'></scroll-nav-bar><div :class='["demo-result"]'>当前 active：{{ currentService }}</div></div><div :class='["demo-block","vertical-demo"]'><scroll-nav-bar direction="vertical" :labels="(serviceList)" :current="(currentService)" use-item-slot="true" @change='(e)=>__invoke(e, [["onServiceChange"]])'><template slot-scope="props"><div :class='[("slot-item "+(props.activeClass))]'><div :class='["slot-item-text"]'>{{ props.index + 1 }}{{ props.txt }}</div></div></template></scroll-nav-bar></div></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_48ee19cf"}'>
.scroll-nav-bar-page
  min-height 100%
  background-color rgba(239, 239, 244, .7)

.demo-block
  margin-bottom 24rpx
  border-radius 24rpx
  overflow hidden
  background-color #fff

.vertical-demo
  height 560rpx

.slot-item
  display flex
  align-items center
  justify-content center
  width 100%
  min-height 88rpx
  padding 0 8rpx
  box-sizing border-box

.slot-item-text
  flex 1
  font-size 28rpx
  line-height 40rpx
  text-align center

.demo-result
  padding 24rpx
  font-size 26rpx
  line-height 38rpx
  color #666
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_48ee19cf"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_48ee19cf"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_48ee19cf"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'scroll-nav-bar-item-renderer':getComponent(require("./item-renderer.mpx?isComponent&outputPath=components%2Fitem-renderer021f3bba%2Findex")),'scroll-nav-bar':getComponent(require("../../../packages/mpx-cube-ui/src/components/scroll-nav-bar/index.mpx?isComponent&outputPath=components%2Findex18bad330%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>